import { LinearProgress } from "@mui/material";

export default function GlobalLoading() {
  return <LinearProgress />;
}
